<script lang="ts">
  import type { HTMLLabelAttributes } from 'svelte/elements';

  let { children, ...props }: HTMLLabelAttributes = $props();
</script>

<label class:form-label={true} {...props}>{@render children?.()}</label>
